import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

export function formatRelativeTime(dateString: string): string {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60_000);
  const diffHours = Math.floor(diffMs / 3_600_000);
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffMinutes < 1) {
    return getTranslation(Resources.Notifications.RelativeTime.JustNow);
  }

  if (diffMinutes < 60) {
    return getTranslation(
      Resources.Notifications.RelativeTime.MinutesAgo,
    ).replace("{{count}}", String(diffMinutes));
  }

  if (diffHours < 24) {
    return getTranslation(
      Resources.Notifications.RelativeTime.HoursAgo,
    ).replace("{{count}}", String(diffHours));
  }

  return getTranslation(Resources.Notifications.RelativeTime.DaysAgo).replace(
    "{{count}}",
    String(diffDays),
  );
}
